import type { AppRuntimeData } from '@wix/ambassador-devcenter-appsruntimereader-v1-app-runtime-data/types';
import { AppRuntimeComponents } from './app-runtime-components';

/**
 * Represents facade entity for GetAppsRuntimeDataResponse type on the apps-runtime-reader service.
 * Mirrors the AppsComponents facade (apps-components.ts) — once specs.app-market.MigrateAppHaveEditorComponentToRuntimeReader
 * is merged, AppComponents (app-components.ts) and AppsComponents (apps-components.ts) can be deleted.
 *
 * @class AppsRuntimeComponents
 */
export class AppsRuntimeComponents {
  constructor(private readonly appsRuntimeData: AppRuntimeData[] | undefined) {}

  findByAppId(appId: string): AppRuntimeComponents {
    return new AppRuntimeComponents(
      this.appsRuntimeData?.find(
        (appRuntimeData) => appRuntimeData.appId === appId,
      ),
    );
  }
}
